<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500px"
    >
      <v-card>
        <form @submit.prevent="submit">
          <v-card-title class="pb-0">
            <span class="headline">{{ $t('finance.initializeCapital') }}</span>
            <v-spacer />
            <v-btn
              flat
              icon
              @click="close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-alert
              type="success"
              :value="done"
            >
              {{ $t('finance.saved') }}
            </v-alert>
            <v-alert
              type="error"
              :value="error"
            >
              {{ $t('finance.couldNotSave') }}
            </v-alert>
            <v-text-field
              v-model.number="amount"
              :label="$t('finance.amountUsdLabel')"
              type="number"
              min="0"
              step="0.01"
              required
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              outline
              @click="close"
            >
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              {{ $t('common.save') }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    value: { type: Boolean, default: false }
  },

  data() {
    return {
      amount: null,
      loading: false,
      done: false,
      error: false
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },

  watch: {
    value(v) {
      if (v) {
        this.done = false
        this.error = false
        this.amount = null
      }
    }
  },

  methods: {
    close() {
      this.$emit('input', false)
    },

    submit() {
      if (this.amount == null || this.amount === '') {
        return
      }
      const token = localStorage.getItem('access_token')
      this.loading = true
      axios
        .post(
          'api/capital/initial',
          { amount: this.amount },
          { headers: { Authorization: 'Bearer ' + token } }
        )
        .then(() => {
          this.error = false
          this.done = true
          this.$emit('saved')
          setTimeout(() => {
            this.done = false
            this.close()
          }, 1200)
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/capital/modals/CapitalInitializeModal.vue